import React, { Component } from "react";
import * as Loader from "../../common/common";
import * as validation from "../../utils/validations";
import { noteCustSupp } from "../../common/config";
import { validateEntitlement } from "../../common/validate-entitlement";
import { FUNCTIONALITY, ENTITLEMENTS } from "../../common/const";
import { Authorize } from "../../components/authorize";
import DropDown from "../../components/form-controls/dropdown";
import { defaultListItem, ddUsersTypess } from "../../common/const";
import * as locationwiseService from "../../services/locationwise/location-wise";

class LocationWise extends Authorize {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  state = {
    register: {
      companyName: "",
      pan: "",
      email: "",
      mobileNo: "",
      password: "",
      repeatPassword: "",
      userName: "",
      userType: "",
      role: "",
      // userVerified: true,
      // userActivate: true,
    },
    validationErrors: {
      userTypeError: "",
      companyNameError: "",
      panError: "",
      emailError: "",
      mobileNoError: "",
      passwordError: "",
      repeatPasswordError: "",
      userTypeValidation: "",
    },
    error: "",
    msg: "",
  };

  onChange(e) {
    const value = e.target.value;
    const name = e.target.name;

    if (name === "pan" || name === "companyName") {
      this.setState({
        register: {
          ...this.state.register,
          [name]: value.toUpperCase(),
        },
      });
    } else {
      this.setState({
        register: {
          ...this.state.register,
          [name]: value,
        },
      });
    }
    let validationErrors = Object.assign({}, this.state.validationErrors);

    if (name === "companyName") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.companyNameError = "Please enter Company Name";
      } else {
        validationErrors.companyNameError = "";
      }
    }

    if (name === "pan") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.panError = "Please enter PAN";
      } else {
        validationErrors.panError = "";
      }
    }
    if (name === "email") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.emailError = "Please provide Email ";
      } else {
        validationErrors.emailError = "";
      }
    }
    if (name === "mobileNo") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.mobileNoError = "Please provide Mobile Number";
      } else {
        validationErrors.mobileNoError = "";
      }
    }
    if (name === "password") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.passwordError = "Please enter Password";
      } else {
        validationErrors.passwordError = "";
      }
    }
    if (name === "repeatPassword") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.repeatPasswordError = "Please enter Confirm Password";
      } else {
        validationErrors.repeatPasswordError = "";
      }
    }
    this.setState({
      validationErrors: validationErrors,
    });
  }

  onKeyPress(e) {
    if (
      e.which === 32 ||
      (e.which !== 8 && isNaN(String.fromCharCode(e.which)))
    ) {
      e.preventDefault();
    }
  }
  onEnter(e) {
    if (e.which === 13) {
      this.onSubmit();
    }
  }

  async onSubmit() {
    Loader.showLoader();
    let {
      userType,
      companyName,
      pan,
      email,
      mobileNo,
      password,
      repeatPassword,
    } = this.state.register;
    let validationFlag = false;
    let validationErrors = Object.assign({}, this.state.validationErrors);

    if (validation.isNullUndefinedEmpty(userType)) {
      validationErrors.userTypeError = "Please select userType Name";
      validationFlag = true;
    }
    // if (!userType.isValidEmail(userType)) {
    //   validationErrors.userTypeValidation = "Please select User Type";
    //   validationFlag = true;
    // } else {
    //   validationErrors.userTypeValidation = "";
    // }

    if (validation.isNullUndefinedEmpty(companyName)) {
      validationErrors.companyNameError = "Please enter Company Name";
      validationFlag = true;
    }
    if (!validation.isValidcompanyName(companyName)) {
      validationErrors.companyNameError = "Please enter valid Company Name";
      validationFlag = true;
    } else {
      validationErrors.companyNameError = "";
    }
    if (validation.isNullUndefinedEmpty(pan)) {
      validationErrors.panError = "Please enter PAN";
      validationFlag = true;
    } else if (!validation.isValidPAN(pan)) {
      validationErrors.panError = "Please enter valid PAN";
      validationFlag = true;
    } else {
      validationErrors.panError = "";
    }

    if (validation.isNullUndefinedEmpty(email)) {
      validationErrors.emailError = "Please provide Email";
      validationFlag = true;
    } else if (!validation.isValidEmail(email)) {
      validationErrors.emailError = "Please provide a valid Email";
      validationFlag = true;
    } else {
      validationErrors.emailError = "";
    }
    if (validation.isNullUndefinedEmpty(mobileNo)) {
      validationErrors.mobileNoError = "Please provide Mobile Number ";
      validationFlag = true;
    } else if (!validation.isValidMobileNo(mobileNo)) {
      validationErrors.mobileNoError =
        "Please provide valid Mobile Number of 10 digits";
      validationFlag = true;
    } else {
      validationErrors.mobileNoError = "";
    }

    if (validation.isNullUndefinedEmpty(password)) {
      validationErrors.passwordError = "Please provide Password";
      validationFlag = true;
    }
    if (password) {
      if (!validation.isValidPasswordFormat(password)) {
        validationErrors.passwordError =
          "Password should be minimum 8 characters containing atleast 1 uppercase 1 lowercase 1 digit and 1 special character.";
        validationFlag = true;
      } else {
        validationErrors.passwordError = "";
      }
      if (
        this.state.register.repeatPassword &&
        this.state.register.repeatPassword !== password
      ) {
        validationErrors.repeatPasswordError =
          "Password and Confirm Password must be same";
        validationFlag = true;
      } else {
        validationErrors.repeatPasswordError = "";
      }
    }
    if (validation.isNullUndefinedEmpty(repeatPassword)) {
      validationErrors.repeatPasswordError = "Please enter Confirm Password ";
      validationFlag = true;
    }
    if (repeatPassword) {
      if (
        this.state.register.password &&
        this.state.register.password !== repeatPassword
      ) {
        validationErrors.repeatPasswordError =
          "Password and Confirm Password must be same";
        validationFlag = true;
      } else {
        validationErrors.repeatPasswordError = "";
      }
    }

    this.setState({
      validationErrors: validationErrors,
    });

    if (validationFlag === false) {
      var data = Object.assign({}, this.state.register);
      data.companyName = companyName.trim();
      data.userName = data.email;
      data.userType = this.state.register.userType;

      if (data.userType === "Customer") {
        data.role = "05";
      }
      if (data.userType === "Supplier") {
        data.role = "06";
      }

      let { response, err } = await locationwiseService.locationWise(data);
      Loader.hideLoader();
      if (err) {
      } else if (response.data && response.data.err) {
        this.setState({
          error: response.data.err,
          msg: "",
          // userVerified: true,
        });
      } else {
        this.setState({
          register: {},
          msg: response.data.msg,
          error: "",
          // userVerified: true,
        });
      }
    } else {
      Loader.hideLoader();
      this.setState({
        // userVerified: true,
      });
    }
  }

  onClear() {
    this.setState({
      register: {
        companyName: "",
        pan: "",
        email: "",
        mobileNo: "",
        password: "",
        repeatPassword: "",
        userName: "",
        userType: "",
        role: "",
      },

      validationErrors: "",
    });
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let {
      companyName,
      pan,
      email,
      mobileNo,
      password,
      repeatPassword,
    } = this.state.register;
    let {
      companyNameError,
      panError,
      emailError,
      mobileError,
      passwordError,
      repeatPasswordError,
      userTypeError,
    } = this.state.validationErrors;

    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="col-sm-12 card pt-3 rounded-0 mt-3">
              <h4 className="text-uppercase text-center mt-0 mb-0 text-primary">
                Location Wise Registration{" "}
              </h4>
              <hr className="mt-1" />
              <div className="row">
                <div className="col-sm-6">
                  <DropDown
                    label="User Type"
                    name="userType"
                    required="true"
                    value={this.state.register.userType || ""}
                    onChange={this.onChange}
                    defaultItem={defaultListItem}
                    list={ddUsersTypess}
                    valProp="value"
                    textProp="name"
                  />
                  <span className="error-msg">{userTypeError}</span>
                </div>
                {this.state.msg ? (
                  <div className="alert alert-success">{this.state.msg}</div>
                ) : null}
                {this.state.error ? (
                  <div className="alert alert-error">{this.state.error}</div>
                ) : null}
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group fg-animate">
                    <span id="loader" className="loading hide"></span>
                    <label htmlFor="Name">
                      Name
                      <span className="mandatory">*</span>
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      value={companyName || ""}
                      onChange={this.onChange}
                      name="companyName"
                      autoComplete="off"
                      maxLength="300"
                      style={{ position: "relative" }}
                    />
                  </div>
                  <span className="error-msg">{companyNameError}</span>
                </div>

                <div className="col-sm-6">
                  <div className="form-group fg-animate">
                    <span id="loader" className="loading hide"></span>
                    <label htmlFor="Name">
                      PAN
                      <span className="mandatory">*</span>
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      maxLength="10"
                      name="pan"
                      value={pan || ""}
                      onChange={this.onChange}
                      autoComplete="off"
                      style={{ position: "relative" }}
                    />
                  </div>
                  <span className="error-msg">{panError}</span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group fg-animate">
                    <span id="loader" className="loading hide"></span>
                    <label htmlFor="Name">
                      Email
                      <span className="mandatory">*</span>
                    </label>
                    <input
                      required
                      type="text"
                      value={email || ""}
                      className="form-control"
                      name="email"
                      onChange={this.onChange}
                      autoComplete="off"
                      maxLength="150"
                      style={{ position: "relative" }}
                    />
                  </div>
                  <span className="error-msg">{emailError}</span>
                </div>

                <div className="col-sm-6">
                  <div className="form-group fg-animate">
                    <span id="loader" className="loading hide"></span>
                    <label htmlFor="Name">
                      Mobile
                      <span className="mandatory">*</span>
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      name="mobileNo"
                      maxLength="10"
                      value={mobileNo || ""}
                      onChange={this.onChange}
                      onKeyPress={this.onKeyPress}
                      autoComplete="off"
                      style={{ position: "relative" }}
                    />
                  </div>
                  <span className="error-msg">{mobileError}</span>
                </div>

                <div className="col-sm-6">
                  <div className="form-group fg-animate">
                    <span id="loader" className="loading hide"></span>
                    <label htmlFor="Name">
                      Password
                      <span className="mandatory">*</span>
                    </label>
                    <input
                      required
                      className="form-control"
                      type="password"
                      maxLength="50"
                      name="password"
                      value={password || ""}
                      onChange={this.onChange}
                      autoComplete="off"
                      style={{ position: "relative" }}
                    />
                  </div>
                  <span className="error-msg">{passwordError}</span>
                </div>

                <div className="col-sm-6">
                  <div className="form-group fg-animate">
                    <span id="loader" className="loading hide"></span>
                    <label htmlFor="Name">
                      Confirm Password
                      <span className="mandatory">*</span>
                    </label>
                    <input
                      required
                      className="form-control"
                      type="password"
                      maxLength="50"
                      name="repeatPassword"
                      value={repeatPassword || ""}
                      onChange={this.onChange}
                      autoComplete="off"
                      style={{ position: "relative" }}
                    />
                  </div>
                  <span className="error-msg">{repeatPasswordError}</span>
                </div>

                <div className="row mb-2">
                  <div className="col-sm-12">
                    {validateEntitlement(
                      FUNCTIONALITY.locationWise,
                      ENTITLEMENTS.edit
                    ) ? (
                      <button
                        className="btn btn-primary rounded-0 ml-2"
                        onClick={this.onSubmit}
                      >
                        Create
                      </button>
                    ) : null}
                    <span>&nbsp;</span>
                    <button
                      className="btn btn-default rounded-0"
                      type="button"
                      onClick={this.onClear}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LocationWise;
